import { authorizedApiClient } from "./config";

export interface CreateMeetingParams {
  workspace_id: string;
  connectionId: string;
  title: string;
  start_time: string;
  end_time: string;
  attendees?: string[];
  description?: string;
  location?: string;
  timeZone?: string;
}

export const createMeeting = async ({
  workspace_id,
  connectionId,
  title,
  start_time,
  end_time,
  attendees,
  description,
  location,
  timeZone,
}: CreateMeetingParams) => {
  // Get timezone from browser or use default
  const userTimeZone = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  const payload: any = {
    summary: title,
    start: {
      dateTime: start_time,
      timeZone: userTimeZone,
    },
    end: {
      dateTime: end_time,
      timeZone: userTimeZone,
    },
  };

  // Add optional fields if provided
  if (description) {
    payload.description = description;
  }
  if (location) {
    payload.location = location;
  }
  if (attendees && attendees.length > 0) {
    // Send attendees as array of email strings
    payload.attendees = attendees;
  }

  return authorizedApiClient.post(`/integration-app/${workspace_id}/create-calendar-event/${connectionId}`, payload);
};
